/**
 * @fileoverview Capitulation Station (Forum) Page
 * The community forum for Capitulators.io with cap_station.png background.
 * 
 * @module pages/forum
 */

import { el } from "../shared/components/simpleRender.js";

/**
 * Renders the Capitulation Station forum page
 * @returns {HTMLElement}
 */
export function renderForumPage() {
  return el("div", { className: "capitulation-station-page" }, [
    // Background layer
    el("div", { className: "station-bg-layer" }, []),
    el("div", { className: "station-overlay" }, []),
    
    // Content
    el("div", { className: "station-page-content" }, [
      // Hero Section
      el("section", { className: "station-hero" }, [
        el("div", { className: "station-hero-content" }, [
          el("h1", { className: "station-hero-title" }, ["Capitulation Station"]),
          el("p", { className: "station-hero-tagline" }, ["Home of the Capitulators"]),
          el("p", { className: "station-hero-description" }, [
            "A message board for the doom-pilled macro community. No algorithms, no engagement farming — just threads, charts, and the collective wisdom of people who've seen this movie before."
          ]),
          el("div", { className: "station-hero-badge" }, [
            el("span", { className: "coming-pill coming-pill--large" }, ["Coming Q1 2026"])
          ])
        ])
      ]),
      
      // Features Section
      el("section", { className: "station-features-section" }, [
        el("h2", { className: "station-section-title" }, ["What to Expect"]),
        el("div", { className: "station-features-grid" }, [
          el("div", { className: "station-feature-card" }, [
            el("span", { className: "feature-icon-large" }, ["📜"]),
            el("h3", {}, ["Long-Form Threads"]),
            el("p", {}, ["Deep dives, multi-part analyses, and the kind of posts that reward re-reading."])
          ]),
          el("div", { className: "station-feature-card" }, [
            el("span", { className: "feature-icon-large" }, ["📊"]),
            el("h3", {}, ["Chart Sharing"]),
            el("p", {}, ["Native chart embedding, markup tools, and annotation features for visual analysis."])
          ]),
          el("div", { className: "station-feature-card" }, [
            el("span", { className: "feature-icon-large" }, ["🎭"]),
            el("h3", {}, ["House Sigils"]),
            el("p", {}, ["Reputation systems, flair, and the digital heraldry of macro twitter refugees."])
          ]),
          el("div", { className: "station-feature-card" }, [
            el("span", { className: "feature-icon-large" }, ["💀"]),
            el("h3", {}, ["Meme Archives"]),
            el("p", {}, ["Because sometimes the best macro analysis comes in PNG format."])
          ]),
          el("div", { className: "station-feature-card" }, [
            el("span", { className: "feature-icon-large" }, ["🔔"]),
            el("h3", {}, ["Stress Alerts"]),
            el("p", {}, ["Real-time notifications when the observatories detect elevated conditions."])
          ]),
          el("div", { className: "station-feature-card" }, [
            el("span", { className: "feature-icon-large" }, ["🏛️"]),
            el("h3", {}, ["Text-First Design"]),
            el("p", {}, ["No bloat, no infinite scroll, no algorithmic timeline. Just threads."])
          ])
        ])
      ]),
      
      // Newsletter Signup (placeholder)
      el("section", { className: "station-notify-section" }, [
        el("div", { className: "station-notify-card" }, [
          el("h2", {}, ["Get Notified at Launch"]),
          el("p", {}, ["Join the waitlist to be among the first to enter when the station opens."]),
          el("div", { className: "station-notify-form" }, [
            el("input", { 
              type: "email", 
              placeholder: "your@email.com",
              className: "station-email-input",
              disabled: true
            }, []),
            el("button", { className: "btn-primary station-notify-btn", disabled: true }, ["Join Waitlist"])
          ]),
          el("p", { className: "station-notify-note" }, ["(Signup coming soon)"])
        ])
      ]),
      
      // Back link
      el("div", { className: "station-back-link" }, [
        el("a", { href: "#/home" }, ["← Back to Home"])
      ])
    ])
  ]);
}

